import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule, formatDate } from '@angular/common';
import { ValueState } from '@app/shared/types';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ReactiveFormsModule } from '@angular/forms';
import { MAT_DATE_LOCALE, MatNativeDateModule, provideNativeDateAdapter } from '@angular/material/core';
import { MatInputModule } from '@angular/material/input';

interface SingleValueDateOutput {
  id: string;
  value: string;
}
@Component({
  selector: 'app-single-value-date',
  standalone: true,
  imports: [
    CommonModule,
    MatDatepickerModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatNativeDateModule,
    MatInputModule,
  ],
  
  providers: [MatDatepickerModule, provideNativeDateAdapter(),
      { provide: MAT_DATE_LOCALE, useValue: 'en-GB' }],
  templateUrl: './single-value-date.component.html',
  styleUrls: ['./single-value-date.component.css'],
})
export class SingleValueDateComponent {
  @Input() public data: {
    state: ValueState;
    label: string;
  };
  @Output() output = new EventEmitter<SingleValueDateOutput>();

  onDataChange(value: Date | string | null) {
    const formattedValue = this.normalizeValue(value);

    this.output.emit({
      id: this.data.state.id,
      value: formattedValue,
    });
  }

  private normalizeValue(value: Date | string | null): string {
    if (!value) {
      return '';
    }

    if (value instanceof Date) {
      return formatDate(value, 'yyyy-MM-dd', 'en-GB');
    }

    return value;
  }
}
